import { render, staticRenderFns } from "./Textarea4Row.vue?vue&type=template&id=14a582de&scoped=true"
import script from "./Textarea4Row.vue?vue&type=script&lang=js"
export * from "./Textarea4Row.vue?vue&type=script&lang=js"
import style0 from "./Textarea4Row.vue?vue&type=style&index=0&id=14a582de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a582de",
  null
  
)

export default component.exports